import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../services/admin.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-biometrics',
  templateUrl: './biometrics.component.html',
  styleUrls: ['./biometrics.component.css']
})

export class BiometricsComponent implements OnInit { 

  public id: string;  
  private value: number = null;
  growth='';
  weight='';
  clothing='';
  shoe='';
  public disabledBtn = true; 
  public successInfo = false;
  public errorInfo = false;

  constructor(public activeModal: NgbActiveModal,
    private userService: UserService) {
  }

  ngOnInit() {
  }

  setId(id) {
    this.id = id;
  }

  setValue(value) {
    this.growth = value.growth;
    this.weight = value.weight;
    this.clothing = value.clothingSize;
    this.shoe = value.shoeSize;
  }

  renameGroup() {
    this.disabledBtn = true;
    this.successInfo = false;
    this.errorInfo = false;

      this.userService.biometrics(this.id, this.growth, this.weight, this.clothing, this.shoe).subscribe(
        (res: any) => {
            this.successInfo = true;
            this.errorInfo = false;
            this.disabledBtn = false;
            this.activeModal.close('ok');
        },
        () => {
          this.errorInfo = true;
        }
      );
  }

  check() {
    if(this.growth && this.weight && this.clothing && this.shoe) {
      this.disabledBtn = false;
    } else {
      this.disabledBtn = true;
    }
  }

  disableBtnValidation1() {
    return this.growth === null;
  }
 
  disableBtnValidation2() {
    return this.weight === null;
  }

  disableBtnValidation3() {
    return this.clothing === null;
  }

  disableBtnValidation4() {
    return this.shoe === null;
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-user-profile/biometrics/biometrics.component.ts